export type DomainNumbering = ReadonlyArray<string | null>;

/**
 * The antibody numbering shown for a residue. A domain with no numbering at all has its
 * residues identified by their 1-based position in the domain's sequence instead.
 *
 * @param residues The sequence of the domain the residue is in.
 * @param numbering The numbering of the domain the residue is in, or null if it has none.
 * @param residueIndex The zero-based index of the residue within the domain.
 */
export function getAntibodyNumbering(
  residues: string,
  numbering: DomainNumbering | null,
  residueIndex: number
): string {
  const residue = residues[residueIndex];
  if (numbering == null || numbering[residueIndex] == null) {
    return `${residue}-idx:${residueIndex + 1}`;
  }
  return `${residue}${numbering[residueIndex]}`;
}
